"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _DraftRound = _interopRequireDefault(require("@rsuite/icon-font/lib/status/DraftRound"));

// Generated by script, don't edit it please.
var DraftRound = (0, _createSvgIcon["default"])({
  as: _DraftRound["default"],
  ariaLabel: 'draft round',
  category: 'status',
  displayName: 'DraftRound'
});
var _default = DraftRound;
exports["default"] = _default;
module.exports = exports.default;